<div class="row">
  <div class="col-md-7 col-lg-6 col-xl-5">
    <div class="campo">
      <form (ngSubmit)="buscar()" name="nameForm" [formGroup]="buscaForm">
        <p>Busque pelo código do aluno</p>
        <a href="#">Não achei o código, e agora?</a>

        <div class="mb-2">
          <input type="text" id="input-nome" class="form-control" formControlName="Codigo">
        </div>

        <div class="mb-2">
          <input type="text" id="input-captcha" class="form-captcha" formControlName="Captcha" mask="AAAA"><span>{{ captcha }}</span>
        </div>

        <button type="submit" class="btn btn-pesquisar" [disabled]="buscaForm.invalid || buscaForm.controls['Captcha'].value != captcha">Pesquisar</button>

        <p id="error-message"></p>
      </form>
    </div>
  </div>

  <div class="col-md-5 col-lg-6 col-xl-7 image-container d-none d-md-flex">
    <img src="assets/images/pesquisa.svg">
  </div>

  <div class="col-lg-5" #Resultado>
    <ng-container *ngIf="!resultadoBusca && naoEncontrado">
      <h5 class="mt-4">Nenhum resultado encontrado. =(</h5>
    </ng-container>

    <ng-container *ngIf="resultadoBusca && !naoEncontrado">
      <h1 class="title">Resultado</h1>

      <table class="table">
        <tbody>
          <tr>
            <td>Nome do aluno:</td>
            <td class="info">{{ resultadoBusca.nomAluno }}</td>
          </tr>
          <tr>
            <td>Sexo:</td>
            <td class="info">{{ resultadoBusca.indSexo == 'F' ? 'Feminino' : 'Masculino' }}</td>
          </tr>
          <tr>
            <td>Data de Nascimento:</td>
            <td class="info">{{ resultadoBusca.dtNascimento | date: 'dd/MM/yyyy':'+0000' }}</td>
          </tr>
          <tr>
            <td>Estado:</td>
            <td class="info">{{ resultadoBusca.ufNaturalidade }}</td>
          </tr>
          <tr>
            <td>Naturalidade:</td>
            <td class="info">{{ resultadoBusca.naturalidade }}</td>
          </tr>
          <tr>
            <td>CPF:</td>
            <td class="info">{{ formataCPF(resultadoBusca.cpfAluno) | mask: 'CPF_CNPJ' }}</td>
          </tr>
          <tr>
            <td>RG:</td>
            <td class="info">{{ resultadoBusca.numIdentidade }}</td>
          </tr>
          <tr>
            <td>Cancelado:</td>
            <td class="info">{{ resultadoBusca.indCancelado == 'N' ? 'Não' : 'Sim' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="col-sm-12 btn-downloads">
        <a [href]="xmlDownloadLink" class="btn btn-orange" [attr.download]="nomeArquivo">Baixar XML</a>
      </div>
    </ng-container>
  </div>
</div>

<!--<ng-container *ngIf="resultadoBusca">
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <pre lang="xml">{{ xmlFile }}</pre>
        </div>
      </div>
    </div>
  </div>
</ng-container>-->
